import React, { useEffect, useState } from 'react'
import { createSelector } from 'reselect'
import { useDispatch, useSelector } from 'react-redux'
import { Box, Container, Grid, CircularProgress, Chip } from '@material-ui/core'
import { Alert, AlertTitle } from '@material-ui/lab'
import WarningRoundedIcon from '@material-ui/icons/WarningRounded'

//HELPERS
import { embedYoutubeVideo } from '../../utils/helpers'

//COMPONENTS
import MenuCategory from '../../components/MenuCategory/MenuCategory'
import BookerForm from '../../components/BookerForm/BookerForm'
import OrderDialog from '../../components/OrderDialog/OrderDialog'
import Carousel from 'react-material-ui-carousel'

//API
import { getEcommerceProducts } from '../../services/FirebaseServices/marketplaceServices'
import { getExperienceGallery } from '../../services/FirebaseServices/experienceServices'

const Ecommerce = ({ agency, singleExperience }) => {
  const [categoryProducts, setCategoryProducts] = useState([])
  const [products, setProducts] = useState([])
  const [gallery, setGallery] = useState([])
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    const unsubscribeProducts = fetchProducts()
    fetchData()

    return function cleanup() {
      unsubscribeProducts()
    }
  }, [])

  async function fetchData() {
    const galleryResponse = await getExperienceGallery(
      agency.key,
      singleExperience.key,
    )

    const validImages = galleryResponse.filter((item) => item !== '')

    setGallery(validImages)
    setIsLoading(false)
  }

  const fetchProducts = () => {
    return getEcommerceProducts(
      agency.key,
      singleExperience.key,
      singleExperience.ecommerceId,
    ).onSnapshot((querySnapshot) => {
      let productData = []
      querySnapshot.forEach((doc) => {
        productData.push(doc.data())
      })
      //Productos que esten activos y sin borrar
      const filterProducts = productData.filter(
        (product) => product.isActive === true && product.isDelete === false,
      )

      const categories = productData.map((product) => product.category)
      //Quitar categorias repetidas
      const removeRepeatedCategories = categories.filter(
        (category, index, self) =>
          index === self.findIndex((t) => t.key === category.key),
      )

      setProducts(filterProducts)
      setCategoryProducts(removeRepeatedCategories)
      setIsLoading(false)
    })
  }

  const filterProducts = (categoryId) => {
    return products.filter((product) => product.category.key === categoryId)
  }

  const handleCarousel = () => {
    const carouselArray = []

    carouselArray.push({
      type: 'video',
      title: singleExperience.name,
      link: singleExperience.linkVideo,
    })

    gallery.forEach((item) => carouselArray.push({ type: 'photo', link: item }))

    return carouselArray
  }

  const handleCategoryWithProducts = () => {
    return categoryProducts.filter((category) => {
      const productExist = filterProducts(category.key).filter(
        (item) => item.isActive === true && item.isDelete === false,
      )
      return productExist.length
    })
  }

  return (
    <>
      <Box>
        <Container style={{ padding: 0 }}>
          {isLoading ? (
            <Box display="flex" justifyContent="center">
              <CircularProgress />
            </Box>
          ) : (
            <>
              <Grid container spacing={2}>
                <Grid item sm={7}>
                  {!handleCategoryWithProducts().length && (
                    <Box textAlign="center">
                      <WarningRoundedIcon
                        style={{ fontSize: 120, color: '#d5d5d5' }}
                      />
                      <h1 style={{ color: '#d5d5d5' }}>
                        La tienda no posee productos registrados.
                      </h1>
                    </Box>
                  )}
                  {handleCategoryWithProducts().map((category) => {
                    return (
                      <MenuCategory
                        category={category}
                        key={category.key}
                        products={filterProducts(category.key)}
                      />
                    )
                  })}
                </Grid>
                <Grid item sm={5}>
                  <Box mb={4}>
                    <BookerForm type="ECOMMERCE" />
                  </Box>

                  {singleExperience.linkVideo ? (
                    <Carousel>
                      {handleCarousel().map((item, index) => {
                        if (item.type === 'video') {
                          return (
                            <iframe
                              title={`exp-${item.title}`}
                              width="100%"
                              height="300px"
                              src={`//www.youtube.com/embed/${embedYoutubeVideo(
                                item.link,
                              )}`}
                              key={index}
                            />
                          )
                        } else {
                          return (
                            <div
                              style={{
                                backgroundImage: `url(${item.link})`,
                                width: '100%',
                                height: '300px',
                                backgroundPosition: 'center center',
                                backgroundSize: 'cover',
                                borderRadius: '15px',
                              }}
                              key={index}
                            ></div>
                          )
                        }
                      })}
                    </Carousel>
                  ) : (
                    <Carousel>
                      {gallery.map((item, index) => {
                        return (
                          <div
                            style={{
                              backgroundImage: `url(${item})`,
                              width: '100%',
                              height: '300px',
                              backgroundPosition: 'center center',
                              backgroundSize: 'cover',
                              borderRadius: '15px',
                            }}
                            key={index}
                          ></div>
                        )
                      })}
                    </Carousel>
                  )}
                  <Box
                    display="flex"
                    flexDirection="column"
                    justifyContent="center"
                  >
                    <p>
                      <b>Descripcion: </b>
                      {singleExperience.description}
                    </p>
                    <p>
                      <b>Ubicacion: </b>{' '}
                      {singleExperience.locator.formatted_address
                        ? singleExperience.locator.formatted_address
                        : singleExperience.locator}
                    </p>
                  </Box>
                </Grid>
              </Grid>
              <OrderDialog
                experienceId={singleExperience.key}
                agencyId={agency.key}
              />
            </>
          )}
        </Container>
      </Box>
    </>
  )
}

export default Ecommerce
